import React from "react";
import "./App.css";
import Navigation from "./components/Navigation";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import { ParallaxProvider } from "react-scroll-parallax";
import ParallaxContainer from "./components/ParallaxContainer";

function App() {
  return (
    <ParallaxProvider>
      <div className="App">
        <Navigation />
        <About />
        <ParallaxContainer />
        <Skills />
        <Projects />
      </div>
    </ParallaxProvider>
  );
}

export default App;
